module.exports = __webpack_public_path__ + "media/images/drivu-black-logo2-02bbeb02f516ac806041ca2ced6f52f6.png";